/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {useEffect, useRef, useState} from 'react';
import Draggable from 'react-draggable';
import {ResizableBox} from 'react-resizable';
import 'react-resizable/css/styles.css';
import ArgosButton from "../../../../../components/Buttons/ArgosButton";
import * as colors from "../../../../../../constants/colors";

const DraggableResizableDialog = (props: any) => {
  const [size, setSize] = useState({width: 600, height: 600});
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateSize = () => {
      if (contentRef.current) {
        const {offsetWidth, offsetHeight} = contentRef.current;
        setSize({width: offsetWidth, height: offsetHeight});
      }
    };

    updateSize();
    window.addEventListener('resize', updateSize);

    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, [contentRef]);

  const onCloseDialog = (e: any) => {
    props.onClose(e);
  }
  if (!props.isOpen) return null;

  return (
    <Draggable handle=".handle">
      <ResizableBox
        width={size.width}
        height={size.height}
        // minConstraints={[200, 200]}
        // maxConstraints={[800, 800]}
        onResize={(e, {size}) => {
          setSize(size);
        }}
        onResizeStop={(e, {size}) => {
          setSize(size);
          if (contentRef.current) {
            contentRef.current.style.width = `${size.width}px`;
            contentRef.current.style.height = `${size.height}px`;
          }
        }}
        resizeHandles={['se']}
        style={{
          border: `1px solid ${colors.tableHeaderGray}`,
          background: 'white',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 10000,
          position: 'fixed',
          top: '25%',
          right: '2%',
          // transform: 'translate(-50%, -50%)',
          // overflow: 'auto'
        }}
      >
        <div ref={contentRef} style={{padding: '10px', flexGrow: 1, overflow: 'auto', display: 'flex', flexDirection: 'column'}}>
          <div className="handle" style={{background: '#ccc', padding: '5px', cursor: 'move'}}>
            <h5>Specify sensor locations for bom</h5>
          </div>
          <div style={{overflow: 'auto', display: 'flex', flexDirection: 'column', flex: 1}}>
            <div style={{overflow: 'auto'}}>
              {props.children}
            </div>
            <div style={{marginTop: 'auto', display: 'flex', justifyContent: 'center', paddingTop: 5, gap: 15}}>
              {/*<ArgosButton onClick={onCloseDialog}>Close</ArgosButton>*/}
              {props.footerItems}
            </div>
          </div>
        </div>
      </ResizableBox>
    </Draggable>
  );
};

export default DraggableResizableDialog;